export default {
  // 扫码类型，eg. 普通扫码: scan / 自定义序列号扫码: epc
  type: {
    type: String,
    default: 'scan',
  },
  visiableInput: {
    type: Boolean,
    default: false,
  },
  btnIsGrayed: {
    type: String,
    default: 'disabled',
  },
  begFormData: {
    type: Object,
    default: () => {
      return {}
    },
  },
  tableColumnDefUrl: {
    type: String,
    default: '',
  },
  tableColumnDataUrl: {
    type: String,
    default: '',
  },
  // 请求参数,json格式或者对象
  requestParam: {
    type: [Object],
    default: () => ({}),
  },
  modalTitle: {
    type: String,
    default: '',
  },
  queryGroupUrl: {
    type: String,
    default: '',
  },
  showEmpty: {
    type: Boolean,
    default: false,
  },
  iconSelection: {
    type: Boolean,
    default: true,
  },
  showAllIconSelection: {
    type: Boolean,
    default: true,
  },
  itemUniqueKeys: {
    // 下表需要显示成减号的对应sideUniqueKey的值的数组
    type: Array,
    default: () => [],
  },
  itemUniqueKey: {
    type: String,
    default: 'parent',
  },
  sideUniqueKey: {
    // 侧滑里的 标记item 唯一的 key
    type: String,
    default: 'id',
  },
  // ----------------------------------------
  store: {
    type: Object,
    default: null,
  },
  itemsKey: {
    type: String,
    default: 'packageItems',
  },
  superAddText: {
    type: String,
    default: '',
  },
  // 自定义事件名（用于配置在按钮上自定义组件）
  eventName: {
    type: String,
    default: 'on-ok-and-continue',
  },
  // 传递的额外参数，例如：传递给 store
  eventParams: {
    type: Object,
  },
  /** @name 确认提交时，是否禁止清空扫码区域表单 */
  disabledClearForSubmit: {
    type: Boolean,
    default: false,
  },
  /** @name 键名转换映射表 */
  propMap: {
    type: Object,
    default() {
      return {
        batchNumber: `${this.dataGoodsKeepingKey}.batchNumber`,
        serialNumber: `${this.dataGoodsKeepingKey}.serialNumber`,
        periodBegin: `${this.dataGoodsKeepingKey}.periodBegin`,
        periodEnd: `${this.dataGoodsKeepingKey}.periodEnd`,
      }
    },
  },
}
